import { render, staticRenderFns } from "./Contrato_Renovacion.vue?vue&type=template&id=23ccd540&scoped=true&"
import script from "./Contrato_Renovacion.vue?vue&type=script&lang=js&"
export * from "./Contrato_Renovacion.vue?vue&type=script&lang=js&"
import style0 from "./Contrato_Renovacion.vue?vue&type=style&index=0&id=23ccd540&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ccd540",
  null
  
)

export default component.exports